import aryaImg from '../../../../assets/testimoni/Arya_Dwiffa.png';
import dhidieImg from '../../../../assets/testimoni/Dhidhie_Sapari.png';
import immanuelImg from '../../../../assets/testimoni/Immanuel_Billy.png';

export const content = [
  {
    img: dhidieImg,
    name: 'Dhidhie Sapari',
    role: 'Owner of SWAG Coffee',
    comment:
      'Aplikasi ini bisa menjadi jalan tengah bagi kafe dan musisi yang sama-sama terdampak pandemi. Dengan menggunakan aplikasi ini pemilik kafe bisa mematok harga yang murah, sedangkan musisi juga tetap bisa mendapatkan job selama pandemi.',
  },
  {
    img: aryaImg,
    name: 'Arya Dwiffa Nugraha',
    role: 'Owner of Kendal Coffee',
    comment:
      'Dengan aplikasi ini saya lebih mudah mendapatkan musisi yang sesuai dengan karakter cafe saya, apalagi selama ini saya hanya mengandalkan circle-circle saya tapi dengan menggunakan aplikasi ini saya bisa menambah circle yang belum saya kenal.',
  },
  {
    img: immanuelImg,
    name: 'Immanuel Billy',
    role: 'Ketua Osis SMK Telkom Malang 2020/2021',
    comment:
      'Dengan aplikasi ini saya lebih mudah mendapatkan musisi yang sesuai dengan karakter cafe saya, apalagi selama ini saya hanya mengandalkan circle-circle saya tapi dengan menggunakan aplikasi ini saya bisa menambah circle yang belum saya kenal.',
  },
];
